import * as React from 'react';
import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';
import { jsx as _jsx } from "react/jsx-runtime";
const mapTags = (pattern, tagsFn, options = {}) => {
  const [firstText, ...pairs] = pattern.split(/\[\[([^\]]*)\]\]/);
  const chunks = chunk(pairs, 2);
  const tags = chunks.reduce((acc, [tagText], index) => {
    const [key, value] = tagText.split(/:(.*)/s);
    acc[key] = value;
    chunks[index][0] = key;
    return acc;
  }, {});
  const transformedTags = tagsFn(tags);
  const missingKeys = Object.keys(transformedTags).filter(key => !(key in tags));
  if (missingKeys.length > 0) {}
  const unhandledKeys = Object.keys(tags).filter(key => !(key in transformedTags));
  if (unhandledKeys.length > 0) {}
  const combinedTags = {
    ...tags,
    ...transformedTags
  };
  const textFn = options.withHTML ? text => /*#__PURE__*/_jsx("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }) : options.textFn || (text => text);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ...[textFn(firstText), ...flatten(chunks.map(([tagKey, text]) => [combinedTags[tagKey], textFn(text)]))].filter(Boolean));
};
export default mapTags;